export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "en": {
        "search": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Search"])},
        "reset": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Reset"])},
        "all": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["All"])},
        "loading": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Loading"])},
        "load_more": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Load more"])},
        "PERSON": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Artists/Producer"])},
        "THEME": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Theme"])},
        "DISTRICT": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["District"])},
        "CLASSIFICATION": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Classification"])},
        "CLOCK_DRIVE": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Power Source"])},
        "ICONCLASS": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Subject"])},
        "MATERIAL": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Material"])},
        "TECHNIQUE": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Technique"])},
        "PLACE": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Place"])},
        "COIN_MINT": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mint"])},
        "COIN_TERRITORY": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mint Territory"])},
        "COLOR": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Color"])}
      },
      "de": {
        "search": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Suchen"])},
        "reset": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zurücksetzen"])},
        "all": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Alle"])},
        "loading": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Lädt"])},
        "load_more": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mehr laden"])},
        "PERSON": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Künstler:in/Hersteller:in"])},
        "THEME": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Thema"])},
        "DISTRICT": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bezirk"])},
        "CLASSIFICATION": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Objektart"])},
        "CLOCK_DRIVE": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Antriebsart"])},
        "ICONCLASS": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bildmotiv"])},
        "MATERIAL": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Material"])},
        "TECHNIQUE": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Technik"])},
        "PLACE": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ort"])},
        "COIN_MINT": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Münzstätte"])},
        "COIN_TERRITORY": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Münzstand"])},
        "COLOR": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Farbe"])}
      }
    }
  })
}
